import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { StatisticsClient, VehicleRunningTotalDTO } from 'src/app/base/models/models.swagger.generated';

@Injectable()
export class RunningTotalsService {

  constructor(
    private statisticsClient: StatisticsClient,
    private toastService: ToastService,
  ) { }

  public getRunningTotals(vehicleId: number): Observable<VehicleRunningTotalDTO[]> {
    return this.statisticsClient.getRunningTotals(vehicleId)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
